import { Controller } from "@hotwired/stimulus"

// Controls collapsible Site sections in the vertical month view of Plantafel
// Persists collapsed/expanded state to localStorage
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { sectionId: String }

  static STORAGE_KEY = "plantafel_vertical_site_section_states"

  connect() {
    // Load saved state from localStorage, default to expanded
    this.expanded = this.loadState()

    // Apply saved state to UI
    this.applyState()
  }

  // Load state from localStorage
  loadState() {
    try {
      const saved = localStorage.getItem(this.constructor.STORAGE_KEY)
      const states = saved ? JSON.parse(saved) : {}
      // Default to expanded (true) if no saved state
      return states[this.sectionIdValue] !== false
    } catch (_e) {
      return true
    }
  }

  // Save state to localStorage
  saveState() {
    try {
      const saved = localStorage.getItem(this.constructor.STORAGE_KEY)
      const states = saved ? JSON.parse(saved) : {}
      states[this.sectionIdValue] = this.expanded
      localStorage.setItem(this.constructor.STORAGE_KEY, JSON.stringify(states))
    } catch (_e) {
      // Ignore storage errors
    }
  }

  // Apply current state to UI elements
  applyState() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden", !this.expanded)
    }

    if (this.hasIconTarget) {
      this.iconTarget.style.transform = this.expanded ? "rotate(0deg)" : "rotate(-90deg)"
    }
  }

  toggle(event) {
    // Prevent event from bubbling
    event.stopPropagation()

    this.expanded = !this.expanded

    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden", !this.expanded)
    }

    if (this.hasIconTarget) {
      // Rotate icon: down (expanded) vs right (collapsed)
      this.iconTarget.style.transform = this.expanded ? "rotate(0deg)" : "rotate(-90deg)"
    }

    this.saveState()
  }
}
